import React from "react";
import "../styles/Navbar.css";

const Navbar = () => {
  return <nav className="navbar">Bee Two</nav>;
};

export default Navbar;
